const mutations = {
    setUserInfo (state, newUserInfo) {
    	newUserInfo && (state.userInfo = newUserInfo)
    }
};
export default mutations;